<template>
  <div>
    <!-- //卡片视图区域 -->
    <el-card>
      <el-row>
        <el-col :span='4'>
          <el-button type='primary' @click='addDialogVisible = true'>
            添加新闻
          </el-button>
        </el-col></el-row
      >
      <!-- 新闻列表区域 -->
      <el-table
        :data='
          newlist.slice((currentPage - 1) * pagesize, currentPage * pagesize)
        '
        border
        stripe
      >
        <el-table-column type='index'></el-table-column>
        <el-table-column label='标题' prop='theme'></el-table-column>
        <el-table-column label='内容' prop='text'></el-table-column>
        <el-table-column label='日期' prop='releaseTime'></el-table-column>
        <el-table-column label='操作'>
          <template slot-scope='scope'>
            <!-- 修改按钮 -->
            <el-button
              type='primary'
              icon='el-icon-edit'
              size='mini'
              @click='showEditDialog(scope.row.id)'
              >修改
            </el-button>
            <!-- 删除按钮 -->
            <el-button
              type='danger'
              icon='el-icon-delete'
              size='mini'
              @click='removeNewById(scope.row.id)'
              >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change='handleSizeChange'
        @current-change='handleCurrentChange'
        :current-page='currentPage'
        :page-sizes='[4]'
        :page-size='pagesize'
        layout='total,  prev, pager, next, jumper'
        :total='newlist.length'
      >
      </el-pagination>
    </el-card>

    <!-- 添加新闻的提示框 -->
    <el-dialog
      title='添加新闻'
      @close='addDialogClosed'
      :visible.sync='addDialogVisible'
      width='50%'
    >
      <!-- 内容主体区 -->
      <el-form :model='addForm' ref='addFormRef'>
        <el-form-item label='新闻标题：' prop='title'>
          <el-input v-model='addForm.title'></el-input>
        </el-form-item>
        <el-form-item label='新闻内容：' prop='content'>
          <el-input
            type='textarea'
            :autosize='{ minRows: 15, maxRows: 15 }'
            v-model='addForm.content'
          ></el-input>
        </el-form-item>
        <el-form-item label='新闻日期：' prop='date'>
          <el-date-picker
            v-model='addForm.date'
            type='date'
            placeholder='选择日期'
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot='footer' class='dialog-footer'>
        <el-button type='primary' @click='addNew'> 确 定</el-button
        ><el-button @click='addDialogVisible = false'>取 消</el-button>
      </span>
    </el-dialog>

    <!-- 修改新闻的对话框 -->
    <el-dialog
      title='修改新闻'
      :visible.sync='editDialogVisible'
      width='50%'
      @close='editDialogClosed'
    >
      <el-form :model='editForm' ref='editFormRef'>
        <el-form-item label='新闻标题：' prop='title'>
          <el-input v-model='editForm.title'></el-input>
        </el-form-item>
        <el-form-item label='新闻内容：' prop='content'>
          <el-input
            type='textarea'
            :autosize='{ minRows: 15, maxRows: 15 }'
            v-model='editForm.content'
          >
          </el-input>
        </el-form-item>
        <el-form-item label='新闻日期：' prop='date'>
          <el-date-picker
            v-model='editForm.date'
            type='date'
            placeholder='选择日期'
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot='footer' class='dialog-footer'
        ><el-button type='primary' @click='editNewInfo'>确 定</el-button>
        <el-button @click='editDialogVisible = false'>取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
export default {
  data () {
    return {
      // 新闻列表
      newlist: [
        {
          id: '',
          title: '',
          content: '',
          date: ''
        }
      ],
      currentPage: 1, // 默认显示第一页
      pagesize: 10, // 默认每页显示4条
      total: '',
      // 控制添加新闻对话框
      addDialogVisible: false,
      // 添加的新闻信息
      addForm: {
        title: '',
        content: '',
        date: ''
      },
      // 控制修改通知对话框的显示
      editDialogVisible: false,
      // 查询到的新闻信息对象
      editForm: {}
    }
  },
  created () {
    this.getNewList()
  },
  methods: {
    async getNewList () {
      const { data: res } = await this.$http.post('/news/selectList', {'currentPage': this.currentPage, 'pageSize': this.pageSize, 'body': {}})
      if (res.code !== 1) {
        return this.$message.error('获取新闻列表失败！')
      }
      this.newlist = res.body.data
      this.total = res.body.coount
    },
    // 监听页码改变
    handleSizeChange (val) {
      this.pagesize = val // 动态改变
      this.getNewList()
    },
    handleCurrentChange (val) {
      this.currentPage = val // 动态改变
      this.getNewList()
    },
    // 监听对话框的关闭
    addDialogClosed () {
      this.$refs.addFormRef.resetFields()
    },
    // 点击按钮添加新闻
    addNew () {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return
        // 可以发起添加新闻的网络请求
        const { data: res } = await this.$http.post(
          '/news/addNews',
          {
            theme: this.addForm.title,
            text: this.addForm.content,
            date: this.addForm.date
          }
        )
        if (res.code !== 1) {
          this.$message.error('添加新闻失败！')
        }
        this.$message.success('添加新闻成功！')
        // 隐藏添加新闻的对话框
        this.addDialogVisible = false
        // 重新获取新闻列表
        this.getNewList()
      })
    },
    // 展示编辑新闻的对话框
    async showEditDialog (id) {
      const { data: res } = await this.$http.post('/news/selectNews', {
        id: id
      })
      if (res.code !== 1) {
        return this.$message.error('查询新闻信息失败!')
      }
      this.editForm = res.data[0]
      this.editDialogVisible = true
    },
    // 监听修改新闻对话框的关闭事件
    editDialogClosed () {
      this.$refs.editFormRef.resetFields()
    },
    // 修改新闻信息并提交
    editNewInfo () {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return
        // 发起修改信息的数据请求
        const { data: res } = await this.$http.post(
          '/news/updNews',
          qs.stringify({
            theme: this.editForm.title,
            text: this.editForm.content,
            date: this.editForm.date,
            id: this.editForm.id
          })
        )
        if (res.status !== 200) {
          return this.$message.error('更新新闻信息失败！')
        }

        // 关闭对话框
        this.editDialogVisible = false
        // 刷新数据列表
        this.getNewList()
        // 提示修改成功
        this.$message.success('更新新闻信息成功！')
      })
    },
    // 根据id删除新闻
    async removeNewById (id) {
      // 弹窗询问用户是否删除数据
      const confirmResult = await this.$confirm(
        '此操作将永久删除该新闻, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch((err) => err)
      // 如果用户确认删除，则返回值为字符串confirm
      // 如果用户了取消了删除，则返回值为字符串 cancel
      // 所以可以考返回值判断用户是否删除
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除')
      }
      const { data: res } = await this.$http.post(
        '/news/delNews/',
        qs.stringify({ id: id })
      )
      if (res.status !== 200) {
        return this.$message.error('删除新闻失败')
      }
      this.$message.success('删除新闻成功')
      this.getNewList()
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/editnews.vue